import axios from "../axiosClient";

export const getLocationBlocks = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Block/getall`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};

export const getUniqueFloorsWithSimilarPlan = async (
  signal: any,
  blockCode: string
) => {
  const res = await axios.get(
    `/slpapp/BlockToFloor/getUniqueFloorsWithSimilarPlan`,
    {
      params: { blockCode },
      signal,
    }
  );

  return res?.data;
};

export const getFloorSubLocations = async (signal: any) => {
  const res = await axios.get(`/slpapp/FloorSubLocation`, {
    signal,
  });

  return res?.data;
};
